import { createSelector } from 'reselect'

export const getReservationConfirmation = createSelector(
  state => state?.scheduleTechnicalInspection?.reservationConfirmation ?? null,
  reservationConfirmation => reservationConfirmation
)
